import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-100 p-2"
}
const _hoisted_2 = { class: "config-grid w-100" }
const _hoisted_3 = {
  key: 2,
  class: "p-float-label w-100 mt-3 p-inputgroup d-flex"
}
const _hoisted_4 = {
  key: 3,
  class: "config-grid w-100 t3"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", { class: "grid-element-full w-100" }, null, -1)
const _hoisted_6 = {
  key: 4,
  class: "config-grid w-100 t3"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", { class: "grid-element-full w-100" }, null, -1)
const _hoisted_8 = {
  key: 7,
  class: "config-grid w-100 t2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfigProperty = _resolveComponent("ConfigProperty")!
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _component_IconPicker = _resolveComponent("IconPicker")!
  const _component_GalleryModal = _resolveComponent("GalleryModal")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Image = _resolveComponent("Image")!
  const _component_HeaderConfigurator = _resolveComponent("HeaderConfigurator")!
  const _component_GalleryConfigurator = _resolveComponent("GalleryConfigurator")!

  return (_ctx.property.format === 'paragraph')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Fieldset, {
          legend: _ctx.$t('editor.' + (_ctx.property.label ? _ctx.property.label : _ctx.id)),
          toggleable: true,
          collapsed: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.value)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.property.properties, (prop, name) => {
                    return (_openBlock(), _createBlock(_component_ConfigProperty, {
                      key: name,
                      class: _normalizeClass(!(prop.type === 'array' || prop.fullWidth ) ? 'grid-element' : 'grid-element-full'),
                      property: prop,
                      value: _ctx.value[name],
                      id: name,
                      onChange: ($event: any) => (_ctx.updateConfig(name,$event))
                    }, null, 8, ["class", "property", "value", "id", "onChange"]))
                  }), 128))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["legend"])
      ]))
    : (_ctx.property.format === 'icon')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.currValue)
            ? (_openBlock(), _createBlock(_component_IconPicker, {
                key: 0,
                icon: _ctx.currValue,
                onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateConfig(null, $event)))
              }, null, 8, ["icon"]))
            : _createCommentVNode("", true)
        ], 64))
      : (_ctx.property.format === 'image')
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
            (_openBlock(), _createBlock(_Teleport, { to: "#modals" }, [
              _createVNode(_component_GalleryModal, {
                id: _ctx.rndId,
                onSelect: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateConfig(null, $event)))
              }, null, 8, ["id"])
            ])),
            _createVNode(_component_InputText, {
              type: "text",
              class: "w-auto",
              modelValue: _ctx.currValue ? _ctx.currValue.itemSrc: '',
              readonly: "",
              "data-bs-toggle": "modal",
              "data-bs-target": '#' + _ctx.rndId
            }, null, 8, ["modelValue", "data-bs-target"]),
            _createElementVNode("label", null, _toDisplayString(_ctx.$t( 'editor.' + (_ctx.property.label ? _ctx.property.label : _ctx.id) )), 1),
            _createVNode(_component_Button, {
              icon: "bi bi-image",
              class: "p-button-info",
              "data-bs-toggle": "modal",
              "data-bs-target": '#' + _ctx.rndId
            }, null, 8, ["data-bs-target"]),
            (_ctx.currValue)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  icon: "bi bi-x",
                  class: "p-button-danger",
                  onClick: _ctx.deleteConfig
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.currValue)
              ? (_openBlock(), _createBlock(_component_Image, {
                  key: 1,
                  class: "ms-2",
                  imageClass: "mini-image",
                  src: _ctx.currValue.itemSrc,
                  preview: true
                }, null, 8, ["src"]))
              : _createCommentVNode("", true)
          ]))
        : (_ctx.property.format === 'module')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_ctx.value)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.property.properties, (prop, name) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: name }, [
                      (prop.format === 'config')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _hoisted_5,
                            _createVNode(_component_ConfigProperty, {
                              class: "grid-element-full",
                              property: _ctx.getConfigByModule(_ctx.value.type, _ctx.value.style),
                              value: _ctx.value[name],
                              onChange: ($event: any) => (_ctx.updateConfig(name,$event)),
                              "parent-information": _ctx.value.type
                            }, null, 8, ["property", "value", "onChange", "parent-information"])
                          ], 64))
                        : (_openBlock(), _createBlock(_component_ConfigProperty, {
                            key: 1,
                            class: _normalizeClass(prop.fullWidth ? 'grid-element-full':'grid-element'),
                            property: prop,
                            value: _ctx.value[name],
                            id: name,
                            onChange: ($event: any) => (_ctx.updateConfig(name,$event))
                          }, null, 8, ["class", "property", "value", "id", "onChange"]))
                    ], 64))
                  }), 128))
                : _createCommentVNode("", true)
            ]))
          : (_ctx.property.format === 'container')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_ctx.value)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.getConfigByObject(_ctx.property, null).properties, (prop, name) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: name }, [
                        (prop.format === 'config')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _hoisted_7,
                              _createVNode(_component_ConfigProperty, {
                                class: "grid-element-full",
                                property: _ctx.getConfigByContainer(_ctx.value.style),
                                value: _ctx.value[name],
                                onChange: ($event: any) => (_ctx.updateConfig(name,$event)),
                                "parent-information": _ctx.value.type
                              }, null, 8, ["property", "value", "onChange", "parent-information"])
                            ], 64))
                          : (_openBlock(), _createBlock(_component_ConfigProperty, {
                              key: 1,
                              class: _normalizeClass(prop.fullWidth ? 'grid-element-full':'grid-element'),
                              property: prop,
                              value: _ctx.value[name],
                              id: name,
                              onChange: ($event: any) => (_ctx.updateConfig(name,$event))
                            }, null, 8, ["class", "property", "value", "id", "onChange"]))
                      ], 64))
                    }), 128))
                  : _createCommentVNode("", true)
              ]))
            : (_ctx.property.format === 'header')
              ? (_openBlock(), _createBlock(_component_HeaderConfigurator, {
                  key: 5,
                  value: _ctx.value,
                  id: _ctx.rndId,
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateConfig(null,$event)))
                }, null, 8, ["value", "id"]))
              : (_ctx.property.format === 'gallery')
                ? (_openBlock(), _createBlock(_component_GalleryConfigurator, {
                    key: 6,
                    value: _ctx.value,
                    id: _ctx.rndId,
                    onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateConfig(null,$event)))
                  }, null, 8, ["value", "id"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (_ctx.value)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.property.properties, (prop, name) => {
                          return (_openBlock(), _createBlock(_component_ConfigProperty, {
                            key: name,
                            class: _normalizeClass(!(prop.type === 'array' || prop.fullWidth ) ? 'grid-element' : 'grid-element-full'),
                            property: prop,
                            value: _ctx.value[name],
                            id: name,
                            onChange: ($event: any) => (_ctx.updateConfig(name,$event))
                          }, null, 8, ["class", "property", "value", "id", "onChange"]))
                        }), 128))
                      : _createCommentVNode("", true)
                  ]))
}